import PropTypes from 'prop-types';

import css from 'styles/components/checkout/caap/address/addressformats/singleLineAddress.scss';

const SingeLineAddress = ({ address = {}, nameOnAddressLine }, { testId }) => {
  if (!Object.keys(address).length) {
    return null;
  }

  const addressContent = addr => {
    const {
      fullName,
      addressLine1,
      addressLine2,
      city,
      stateOrRegion,
      postalCode
    } = addr;

    return (
      <div className={css.singleLineAddressWrapper}>
        {
          nameOnAddressLine
            ? <div className={css.addressContent} data-test-id={testId('singleLineAddressWithName')}>
              {
                `${fullName},
              ${addressLine1},
              ${addressLine2 ? `${addressLine2}, ` : ''}
              ${city},
              ${stateOrRegion},
              ${postalCode}`
              }
            </div>
            : <div>
              <div className={css.forceWrap}>
                <strong>{fullName}</strong>
              </div>
              <div className={css.addressContent} data-test-id={testId('singleLineAddress')}>
                {
                  `${addressLine1},
                ${addressLine2 ? `${addressLine2}, ` : ''}
                ${city},
                ${stateOrRegion},
                ${postalCode}`
                }
              </div>
            </div>
        }
      </div>
    );
  };

  return (
    addressContent(address)
  );
};

SingeLineAddress.contextTypes = {
  testId: PropTypes.func
};

export default SingeLineAddress;
